import React from "react";
import CustomSelect from "../../../UI Component/CustomSelect/CustomSelect";

const PainScale = (props) => {
  const {
    name,
    selectedName,
    painScaleData,
    handleRadioBtn,
    handlePainScaleInput,
    handlePainScaleSelect,
  } = props;

  const radioButtonList = [
    {
      label: "Left",
      value: "left",
    },
    {
      label: "Right",
      value: "right",
    },
    {
      label: "Bilateral",
      value: "bilateral",
    },
  ];

  const generatePainLevel = () => {
    let arr = [];
    for (let index = 1; index <= 10; index++) {
      let obj = {};
      obj["label"] = index + "";
      obj["value"] = index + "";
      arr.push(obj);
    }
    return arr;
  };

  // <---- UI

  const renderDropdown = () => {
    return (
      <div className={"mr-sm-0 mr-lg-4 mr-0"} style={{ width: "200px" }}>
        <div>Pain Scale</div>
        <CustomSelect
          className="select_dropdownOptions"
          placeholder=""
          options={generatePainLevel()}
          value={painScaleData?.selected_option}
          handleChange={(newValue) =>
            handlePainScaleSelect(selectedName, newValue)
          }
          isSearchable={false}
          menuIsOpen={true}
        />
      </div>
    );
  };
  const renderInputField = () => {
    return (
      <div>
        <div>Since</div>
        <input
          className="pain-scale-input"
          onChange={(e) => handlePainScaleInput(selectedName, e.target.value)}
          value={painScaleData?.since}
        />
      </div>
    );
  };

  const renderRadioBtn = () => {
    return (
      <div className="d-flex mt-3">
        <div className="d-flex align-items-center pain-scale-radio-button">
          {radioButtonList.map((data) => (
            <>
              <input
                type="radio"
                value={data?.label}
                id={data?.value}
                onChange={(e) => handleRadioBtn(selectedName, e.target.value)}
                name="area"
                checked={
                  data?.label?.toLowerCase() ===
                  painScaleData?.area?.toLowerCase()
                }
              />
              <label htmlFor={data?.value} className="mb-0 px-2 mr-3">
                <span>{data?.label}</span>
              </label>
            </>
          ))}
        </div>
      </div>
    );
  };

  // ------>
  return (
    <div className="pain-scale-container p-3">
      <div className="d-flex flex-sm-column flex-lg-row flex-column">
        {renderDropdown()}
        {renderInputField()}
      </div>
      {renderRadioBtn()}
    </div>
  );
};

export default PainScale;
